










import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import TableEvaluationList from '../../components/templates/CompanyInformation/TableEvaluationList.vue'
import TableFavoriteUser from '../../components/templates/CompanyInformation/TableFavoriteUser.vue'
import CompanyInformation from '../../components/templates/CompanyInformation/CompanyInformation.vue'
import Evaluation from '../../components/templates/CompanyInformation/Evaluation.vue'
import Loading from '../../components/molecules/Loading.vue'
import router from '../../router'
export default createComponent({
  setup (props, context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }

    onMounted( async () => {
      //await company.clearBtnCardText()
      await company.getIndustryCode().then(() => company.getCompanyInfor())
    })

    const loading = computed(() => company.loading)
    return {
      loading,
    };
  },
  components : {
    TableEvaluationList,
    TableFavoriteUser,
    CompanyInformation,
    Evaluation,
    Loading
  },
})
